import useMediaQuery from '../../hooks/useMediaQuery';

export const useIsTablet = () => useMediaQuery('(max-width: 1024px)');
